import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=6867104e"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports